import styled from 'styled-components';
import dayjs from 'dayjs';
import { FilterType } from '../FilterData';
import { useState } from 'react';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  ResetButton,
} from './OptionModal.styles';
import DatePicker from '../../components/calendar/DatePicker';

interface Props {
  option: 'saleDate' | 'approvalDate';
  option2: 'start' | 'end';
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function DateOption({ option, option2, onClose, filters, setFilters }: Props) {
  const [selected, setSelected] = useState(filters[option]?.[option2]);

  const handleReset = () => {
    setSelected('');
    // setCurrent(dayjs());
  };

  const handleSubmit = () => {
    setFilters({
      ...filters,
      [option]: {
        ...filters[option],
        [option2]: selected,
      },
    });
    onClose();
  };
  return (
    <div>
      <Content>
        <DatePicker selected={selected} setSelected={setSelected} />
      </Content>
      <Bottom>
        <ButtonBox>
          <ResetButton onClick={handleReset}>
            <img
              src="/assets/images/icon/reset.svg"
              alt=""
              width={24}
              height={24}
            />
            <span>초기화</span>
          </ResetButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </div>
  );
}

export default DateOption;

const Content = styled.div`
  border-bottom: 1px solid #e1e2e4;
  padding: 24px 16px;
`;
